// Centralized SEO Configuration
// This ensures domain consistency across the entire application

export const SEO_CONFIG = {
  // Primary domain - CHANGE THIS IF YOUR DOMAIN IS DIFFERENT
  baseUrl: process.env.NODE_ENV === 'production' 
    ? (process.env.REACT_APP_BASE_URL || 'https://kundlishastra.com')
    : 'http://localhost:3000',
  
  siteName: 'Kundli Shastra',
  siteDescription: 'Vedic astrology and numerology platform offering birth chart analysis, astrological insights, and personalised reports',
  
  // Default image for social sharing
  defaultImage: `${process.env.PUBLIC_URL || ''}/og-image.jpg`,
  defaultLogo: `${process.env.PUBLIC_URL || ''}/logo-ks-new.png`,
  
  // Default keywords (used as fallback)
  defaultKeywords: 'vedic astrology, kundli, birth chart, horoscope, lagna, moon sign, numerology, natal chart, astrological insights, divisional charts, ashtakavarga, dasha, varshaphal',
  
  // Author information
  author: 'Kundli Shastra',
  
  // Social media
  twitterHandle: '@kundlishastra', // Update if you have Twitter
  facebookPage: 'https://facebook.com/kundlishastra', // Update if you have Facebook
  
  // Contact
  contactEmail: 'support@kundlishastra.com',
  
  // Languages supported (for future hreflang implementation)
  supportedLanguages: [
    { code: 'en', name: 'English' },
    { code: 'hi', name: 'Hindi' },
    { code: 'bn', name: 'Bengali' },
    { code: 'te', name: 'Telugu' },
    { code: 'mr', name: 'Marathi' },
    { code: 'ta', name: 'Tamil' },
    { code: 'gu', name: 'Gujarati' },
    { code: 'kn', name: 'Kannada' },
    { code: 'ml', name: 'Malayalam' },
    { code: 'or', name: 'Odia' },
    { code: 'pa', name: 'Punjabi' },
    { code: 'as', name: 'Assamese' }
  ]
};

// Helper function to get full URL
export const getFullUrl = (path = '') => {
  const base = SEO_CONFIG.baseUrl.replace(/\/$/, ''); // Remove trailing slash
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${base}${cleanPath}`;
};

// Helper function to get image URL
export const getImageUrl = (imagePath) => {
  if (imagePath.startsWith('http')) {
    return imagePath;
  }
  const base = SEO_CONFIG.baseUrl.replace(/\/$/, '');
  const cleanPath = imagePath.startsWith('/') ? imagePath : `/${imagePath}`;
  return `${base}${cleanPath}`;
};

